<template>
  <component :is="authLayout" transition="slide-fade" transition-mode="out-in">
    <v-container fluid grid-list-xl pa-0>
      <app-breadcrumb title="Profile Settings"></app-breadcrumb>
      <v-layout row wrap>
        <v-flex lg3 md3 sm3 xs12>
          <user-info />
        </v-flex>
        <v-flex lg9 md9 sm9 xs12>
          <transition name="slide-fade" mode="out-in">
            <router-view/>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </component>
</template>

<script>
import UserInfo from '../components/profile/settings/userInfo'
export default {
  name: 'authSettings',
  data () {
    return {
      authLayout: 'auth-layout'
    }
  },
  components: {
    UserInfo
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || this.defaultLayout) + '-layout'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/authSettings.vue